import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Box, Button, Flex, Group, Image } from '@mantine/core';
export type BuyButtonProps = {
  handleClick: () => void;
};
export const BuyButton: React.FC<BuyButtonProps> = ({
  handleClick
}) => {
  const {
    i18n
  } = useLingui();
  return <Flex justify={{
    base: 'center',
    sm: 'end'
  }}>
      <Box>
        <Button fz={13} h={46} fw={700} mt={8} w={200} classNames={classes} onClick={handleClick} leftSection={<Icons className="icon-pr-line-card" fontSize={24} />}>
          {i18n._('BUY CRYPTO')}
        </Button>
        <Group mt={14} justify="space-between">
          <Image src="/assets/wallet/visa.png" w={83} h={27} alt="visa" />
          <Image src="/assets/wallet/mastercard.png" w={56} h={56} alt="card" />
        </Group>
      </Box>
    </Flex>;
};